import { render } from "./TextSectionHeadline.vue?vue&type=template&id=498a50d6&ts=true"
import script from "./TextSectionHeadline.vue?vue&type=script&lang=ts"
export * from "./TextSectionHeadline.vue?vue&type=script&lang=ts"

import "./TextSectionHeadline.vue?vue&type=style&index=0&id=498a50d6&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__